﻿export class Notifications {

    static notificationCookieName = ".clubpal.toast";
    static alertCookieName = ".clubpal.alert";

    static init() {
        window.addEventListener('load', function () {

            const notificationCookie = Notifications.getCookie(Notifications.notificationCookieName);
            if (notificationCookie) {

                let values = Notifications.parseQuery(notificationCookie);
                if (values["message"]) {
                    showMessage({message: values["message"], type: values["type"]});

                    Notifications.setCookie(Notifications.notificationCookieName, "", -1);
                }
            }

            const alertCookie = Notifications.getCookie(Notifications.alertCookieName);
            if (alertCookie) {

                let values = Notifications.parseQuery(alertCookie);
                if (values["message"]) {
                    Notifications.alert.fire({ title: values["title"], html: values["message"]});
                }
                Notifications.setCookie(Notifications.alertCookieName, "", -1);
            }
        });
    }

    static setNotificationCookie(title) {
        Notifications.setCookie(btoa(`message=${title}&type=success`), 1);
    }

    /**
     *
     * @param {object} options - Options
     * @param {string} options.message - The message for the notification
     * @param {string} [options.title] - An optional title for the notification
     * @param {number} [options.timeout] - The time in milliseconds to show the notification. Set to 0 to not auto-hide.
     */
    static showSuccess = (options) => {
        options.type = "success";

        showMessage(options);
    }

    /**
     *
     * @param {object} options - Options
     * @param {string} options.message - The message for the notification
     * @param {string} [options.title] - An optional title for the notification
     * @param {number} [options.timeout] - The time in milliseconds to show the notification. Set to 0 to not auto-hide.
     */
    static showError = (options) => {
        options.type = "error";

        showMessage(options);
    }

    /**
     *
     * @param {object} options - Options
     * @param {string} options.message - The message for the notification
     * @param {string} [options.title] - An optional title for the notification
     * @param {number} [options.timeout] - The time in milliseconds to show the notification. Set to 0 to not auto-hide.
     */
    static showWarning = (options) => {
        options.type = "warning";

        showMessage(options);
    }

    /**
     *
     * @param {object} options - Options
     * @param {string} options.message - The message for the notification
     * @param {string} [options.title] - An optional title for the notification
     * @param {number} [options.timeout] - The time in milliseconds to show the notification. Set to 0 to not auto-hide.
     */
    static showInfo = (options) => {
        options.type = "warning";

        showMessage(options);
    }

    static confirm = Swal?.mixin({
        showConfirmButton: true,
        showDenyButton: true,
        reverseButtons: true,
        customClass: {
            actions: "d-flex justify-content-between w-100",
            confirmButton: "px-10 btn btn-primary d-flex align-items-center",
            denyButton: "px-10 btn btn-danger d-flex align-items-center",
            input: ''
        },
        confirmButtonText: '<i class="bi bi-check-circle fs-3"></i> Yes',
        denyButtonText: '<i class="bi bi-x-circle fs-3"></i> No',
    });

    static alert = Swal.mixin({
        showConfirmButton: true,
        showDenyButton: false,
        reverseButtons: false,
        customClass: {
            actions: "d-flex justify-content-center w-100",
            confirmButton: "px-10 btn btn-light-primary d-flex align-items-center",
            input: ''
        },
        confirmButtonText: 'OK!'
    });

    static setCookie(cookieName, value, minutes) {
        let expires = "";
        if (minutes) {
            const date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = cookieName + "=" + (value || "") + expires + "; path=/";
    }

    static getCookie(cookieName) {
        let nameEQ = cookieName + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                let value = decodeURIComponent(c.substring(nameEQ.length, c.length));
                return atob(value);
            }
        }

        return null;
    }

    static parseQuery(queryString) {
        let query = {};
        let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (let i = 0; i < pairs.length; i++) {
            let pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }
}

let container;

const alertTemplate = Handlebars.compile(`
    <div>
        {{#if title}}
        <div class="fs-5 fw-bold mb-2">{{title}}</div>
        {{/if}}
        <div class="d-flex align-items-center justify-content-between fs-6">
            <div class="flex-grow-1">
                {{message}}
            </div>
            <a class="close" href="#"><i class="bi-x fs-2x text-gray-500"></i></a>
        </div>
        <div class="progress-bar-container"><div class="timer-progress-bar w-50"</div>
    </div>
`);

const ensureContainer = () => {
    if(container)
        return container;

    container = document.createElement("div");
    container.id = "snackbar";

    document.body.appendChild(container);

    return container;
};

/**
 *
 * @param {object} options - Options
 * @param {string} options.message - The message for the notification
 * @param {("success" | "warning" | "error" | "info")} options.type - The type of notification to display. Options are success, warning, error, info.
 * @param {string} [options.title] - An optional title for the notification
 * @param {number} [options.timeout] - The time in milliseconds to show the notification. Set to 0 to not auto-hide.
 */

const showMessage = (options) => {

    const timeout = options.timeout ?? 5000;

    const alert = document.createElement("div");
    alert.innerHTML = alertTemplate(options);

    ensureContainer().appendChild(alert);
    alert.className = `snack ${options.type} show`;

    const closeButton = alert.querySelector("a.close");
    closeButton.addEventListener("click", (e) => {
        e.preventDefault();

        hideAlert();
    });

    if(timeout > 0) {
        setTimeout(hideAlert, timeout);
    }

    function hideAlert() {
        alert.remove();
    }
};

